// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"236":"translation-en-error-json","535":"translation-en-login-json"}[chunkId] + "." + {"236":"b07650540354d7d0a1fb","535":"52fe7a067a5fa6432b93"}[chunkId] + ".chunk.js";
};